import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, Input } from "@base/ui";
import { Check, Copy } from "lucide-react";
import { useState } from "react";

/**
 * Campo so de leitura com o link do convite ou da redefinicao, para copiar e
 * mandar por WhatsApp quando o e-mail nao esta configurado ou a caixa nao chegou.
 */
export function CampoDeLinkCopiavel({
  link,
  rotulo = "Link para cadastrar a senha",
}: {
  readonly link: string;
  readonly rotulo?: string;
}) {
  const [copiado, setCopiado] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="link-de-senha" className="text-sm font-medium">
        {rotulo}
      </label>
      <div className="flex gap-2">
        <Input id="link-de-senha" readOnly value={link} onFocus={(evento) => evento.target.select()} />
        <Button
          type="button"
          variant="outline"
          onClick={() => {
            void navigator.clipboard.writeText(link).then(() => setCopiado(true));
          }}
        >
          {copiado ? <Check aria-hidden="true" /> : <Copy aria-hidden="true" />}
          {copiado ? "Copiado" : "Copiar"}
        </Button>
      </div>
    </div>
  );
}

export function DialogoDoLinkDeSenha({
  aberto,
  titulo,
  descricao,
  link,
  aoFechar,
}: {
  readonly aberto: boolean;
  readonly titulo: string;
  readonly descricao: string;
  readonly link: string | null;
  readonly aoFechar: () => void;
}) {
  return (
    <Dialog
      open={aberto}
      onOpenChange={(proximo) => {
        if (!proximo) aoFechar();
      }}
    >
      <DialogContent tamanho="formulario">
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          <DialogDescription>{descricao}</DialogDescription>
        </DialogHeader>
        {link ? <CampoDeLinkCopiavel link={link} /> : null}
        <Button type="button" variant="outline" onClick={aoFechar}>
          Fechar
        </Button>
      </DialogContent>
    </Dialog>
  );
}
